import { Loader } from "@crunchyroll/cx-web-components";

import styles from "./Shell.module.scss";
import NotFound from "../../features/notFound/NotFound";

const Shell = ({ isNotFound }) => {
  if (isNotFound) {
    return <NotFound />;
  }
  return (
    <div className={styles.shell}>
      <Loader size="l" />
    </div>
  );
};

export default Shell;
